import { useEffect, useState } from 'react';

/** Devolve `value` atrasado por `delay` ms — usado para não disparar rede a cada tecla. */
export function useDebouncedValue<T>(value: T, delay = 400): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
